export const getSizeInMb = (size: string | number) => {
	const value = Number(size)
	if (!isNaN(value)) {
		return `${(value / 1024 / 1024).toFixed(2)} MB`
	}
	return size
}
